import { connect, no_render } from 'core'
import GroupMaterial from 'comp/right/group_material';
import * as selectors from 'selectors';
import { cache } from 'utils';

const sort_name = (a, b) => a.name > b.name;

const mapToProps = state => {
  const selected = selectors.getSelectedGroup(state.ui.selected_group)
  if(!selected) {
    return no_render
  }
  return {
    jumping:state.ui.jump_to_conv,
    group_id: selected.id,
    upload_list: selectors.getFilesForUploadList({ g_id: `material`, u_id: selected.id }),
    add_status: state.fetch.group_add_materials || cache.empty_obj,
    remove_status: state.fetch.group_remove_materials || cache.empty_obj,
    materials: selectors.objToArray(state, 'group', selected.id, 'materials', sort_name),
    is_admin: selected.is_admin
  };
};

export default connect(GroupMaterial,mapToProps);



// WEBPACK FOOTER //
// ./src/containers/right/GroupMaterial.js